import { makePropCacheMixin } from '../utils/cache';
export default makePropCacheMixin('$listeners', 'bvListeners');


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/mixins/listeners.js
// module id = 87
// module chunks = 0